import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProjectSettingsDetailViewTopBar } from "./TopBar"

export const projectSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProjectSettingsDetailViewTopBar,
}
